<script>
import VueSelect from 'vue-select';
import RequisitionCrud from './Crud.vue';
import RedactorControl from '../RedactorControl.vue';
import InputFileControl from '../FileInputControl.vue';
import Modal from './AdPreviewModal.vue'
import { debounce } from 'lodash'

export default {
    components: {
        VueSelect,
        RequisitionCrud,
        RedactorControl,
        Modal,
        InputFileControl,
    },

    props: {
        approval: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object,
            required: true,
        },
        requisition: {
            type: Object,
            required: true
        },
        ad: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: false
        },
        errors: {
            type: Object,
            default: {}
        },
        pdfUrl: {
            type: String,
            required: false
        },
        isPipeline: {
            type: String,
            default: 'requisition'
        }
    },

    data() {
        return {
            adDetails: (this.ad.details) ? this.ad.details : '',
            images: this.ad.images || [],
            users: this.ad.user ? [this.ad.user] : [],
            approver: this.ad.user || null,
            adDisplayTitle: this.requisition.display_title || '',
        }
    },

    methods: {
        reqInputClicked(title, val) {
            this.adDetails = this.adDetails + `<p>
                <strong>${title}</strong>
                <br>
                ${val}
            </p>`;
        },
        toggleModal() {
            this.$refs.modal.toggle();
        },
        fetchUsers(search = '', loading = null) {
            if (loading) loading(true);
            this.search(`/recruiter/users/requisition-approvers.json?search=${search}&limit=1000`, loading, json => {
                this.users = json.users
            });
        },
        search: debounce((url, loading, mapResult) => {
            fetch(url).then(res => {
                res.json().then(mapResult);
                if (loading) loading(false);
            });
        }, 250),
        removeImages(index) {
            this.images.splice(index, 1)
        },
        setImageFileUrl(e, index) {
            let file_url = URL.createObjectURL(e.target.files[0])

            if (this.images[index].file_url == '' || this.images[index].file_url == null) {
                this.images[index].file_url_local = file_url;
            } else {
                this.images[index].file_url = file_url;
            }
        }
    },
}
</script>

<template>
    <div class="requisition-ad-crud">

        <div class="large reveal" data-reveal id="ad-preview">
            <div class="close-button" data-close aria-label="Close modal">
                <span aria-hidden="true">&times;</span>
            </div>
            <iframe style="width: 100%; height: 75vh;"></iframe>
        </div>

        <div v-if="errors.length > 0" class="errors mb-4">
            <ul>
                <li v-for="error in errors">
                    {{ error }}
                </li>
            </ul>
        </div>

        <div class="grid-x grid-padding-x">
            <div class="cell large-4 ad-creation-container">
                <div class="approve-header">
                    <div class="header-text">{{ (isPipeline) ? 'Pipeline' : 'Requisition' }} Details</div>
                </div>

                <requisition-crud
                    :inputsClickable="!approval"
                    flow="readonly"
                    :compact="true"
                    :requisition='requisition'
                    :industries='[]'
                    :provinces='[]'
                    :contractTypes='[]'
                    :hide-status="true"
                    :inputs-clickable="true"
                    @input-clicked="reqInputClicked"
                    questions-class=''
                />
            </div>

            <div class="cell large-4 ad-creation-container">
                <div class="approve-header">
                    <div class="header-text">Ad Creation</div>
                </div>

                <div class="ad-creation-forms">
                    <form method="POST" enctype="multipart/form-data">
                        <div class="mb-4">
                            <label>Ad Creation Details</label>
                            <div v-if="approval" class="textarea" v-html="adDetails"></div>
                            <redactor-control v-else
                                name="details"
                                v-model="adDetails"
                                :config="{ plugins: [ 'alignment', 'table', 'fullscreen', 'limiter', 'counter', 'specialchars', 'fontcolor' ], callbacks: {} }"
                            />
                        </div>
                        <div class="mb-4">
                            <label>Display Title</label>

                            <div v-if="approval" class="textarea" v-html="adDisplayTitle"></div>
                            <input v-else name="display_title" type="text" v-model="adDisplayTitle" />
                        </div>
                        <input v-if="images.length == 0" name="images" value="" type="hidden" />
                        <div v-if="!approval">
                            <div v-for="(image, i) in images" class="mb-4" :key="`image-${image.id}`">
                                <input v-if="image.file_url" :name="`images[${i}][id]`" type="hidden" :value="image.id" />
                                <label>
                                    Image #{{ i + 1 }}
                                    <small class="view-existing" v-if="image.file_url">(Existing: <a target="_blank" :href="image.file_url">view</a>)</small>

                                    <a v-if="!approval" @click.prevent="removeImages(i)" class="remove-image">Remove</a>
                                </label>
                                <InputFileControl :name="`images[${i}][file_path]`" @change="setImageFileUrl($event, i)" :label-placeholder="image.file_url ? image.file_url.split('/').pop() : 'Upload file here'" />
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="images.length > 0">
                                <label>Image/s Uploaded</label>
                                <div  class="cell textarea images-uploaded">
                                    <small><i class="fas fa-image"></i></small>&nbsp;&nbsp;<small v-for="(image, i) in images" :key="`uploaded-image-${image.id}`" class="view-existing" v-if="image.file_url"><a target="_blank" :href="image.file_url">Image #{{ i+ 1 }}</a>, </small>
                                </div>
                            </div>
                            <div class="cell shrink">
                                <button @click="toggleModal" type="button" class="mt-3 outlined-grey text-uppercase">
                                    View Ad
                                </button>
                                <a :href="pdfUrl" target="_blank">
                                    <button type="button" class="mt-3 outlined-grey text-uppercase">Export to PDF</button>
                                </a>
                            </div>
                        </div>

                        <div v-if="!approval" class="mb-4">
                            <button @click="() => images.push({file_url_local : '', id: (Math.random()*100)})" class="button primary" type="button">+ Add Image</button>
                        </div>

                        <div class="mb-4 mt-4">
                            <label>Approver</label>
                            <input v-if="!approval" name="approver_id" type="hidden" :value="approver ? approver.id : null" />
                            <vue-select
                                :disabled="approval"
                                label="full_name"
                                @search="fetchUsers"
                                @open="fetchUsers"
                                :options="users"
                                v-model="approver"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.full_name }} ({{ option.role }})
                                </template>
                            </vue-select>
                        </div>

                        <div class="grid-x grid-padding-x" v-if="!approval">
                            <div class="cell shrink">
                                <button :disabled="!approver || approval || (adDetails === '')" type="submit" name="status" value="created" class="button info">
                                    Save Progress
                                </button>
                            </div>
                            <div class="cell shrink">
                                <button :disabled="!approver || approval || (adDetails === '')" type="submit" name="status" value="pending" class="button success">
                                    Request Approval
                                </button>
                            </div>
                            <div v-if="!approval" class="cell shrink">
                                <button @click="toggleModal" type="button" class="button outlined-grey">
                                    View Ad
                                </button>
                            </div>
                        </div>
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                    </form>
                </div>
            </div>

            <div v-if="approval" class="cell large-4 ad-creation-container">
                <div class="approve-header">
                    <div class="header-text">Comments & Approval</div>
                </div>

                <form v-if="ad.status != 'approved'" method="POST" class="approval-form">
                    <div class="mb-4 comments-ad-approval-section">
                        <label>Comments</label>
                        <textarea v-if="user.id != ad.approver_id && user.role != 'super_admin'" :disabled="user.id != ad.approver_id && user.role != 'super_admin'" name="comments" required v-model="ad.comments" rows="5"></textarea>
                        <redactor-control v-else
                            name="comments"
                            v-model="ad.comments"
                            rows="5"
                            :config="{ plugins: [ 'alignment', 'table', 'fullscreen', 'limiter', 'counter', 'specialchars', 'fontcolor' ], callbacks: {} }"
                        />
                        <textarea v-if="approval" class="d-none" v-model="adDetails" name="details"></textarea>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div class="cell">
                            <button :disabled="user.id != ad.approver_id && user.role != 'super_admin'" type="submit" name="status" value="declined" class="button alert text-uppercase">
                                Decline - Please Update
                            </button>
                        </div>
                        <div class="cell">
                            <button :disabled="user.id != ad.approver_id && user.role != 'super_admin'" type="submit" name="status" value="approved" class="button approve-button mt-2 text-uppercase">
                                Approve
                            </button>
                        </div>
                    </div>
                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                </form>

                <template v-else>
                    <div class="mb-4 comments-section">
                        <label>Comments</label>

                        <div class="full-textarea" :disabled="true" required v-html="ad.comments" rows="5"></div>
                    </div>
                    <p class="status">
                        <i class="fa" :class="ad.status == 'approved' ? 'fa-check' : 'fa-times'"></i>
                        <strong>{{ ad.status | capitalize }}</strong>
                    </p>
                    <div class="grid-x grid-padding-x">
                        <form :action="`/recruiter/requisitions/publish-to-job-portal/${requisition.id}`" method="POST" class="cell shrink">
                            <input type="hidden" name="_csrfToken" :value="csrfToken" />
                            <button type="submit" class="button success">
                                Publish to Job Portal
                            </button>
                        </form>
                    </div>
                </template>
            </div>
        </div>

        <modal ref="modal" heading="Requisition Preview">
            <div class="bg-white rounded p-4 mb-4">
                <div class="requisition-preview">
                    <img class="logo" :src="requisition.job_profile.company.wide_logo_url" />
                    <div class="title">{{ requisition.job_profile.title }}</div>
                    <div v-html="adDetails" class="mb-4"></div>
                    <strong>Images</strong>
                    <div class="grid-x grid-padding-x">
                        <div v-for="(image, i) in images" class="cell small-6 medium-4 large-3 xlarge-2" :key="`image_url-${i}`">
                            <img v-if="image.file_url" :src="image.file_url" :alt="`Req. Image #${i + 1}`" />
                            <img v-if="image.file_url_local" :src="image.file_url_local" :alt="`Req. Image #${i + 1}`" />
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<style>
.remove-image, .view-existing {
    font-weight: normal;
}

.remove-image, .view-existing a {
    text-decoration: underline;
    color: cornflowerblue;
}
</style>